import { Reveal, OceanTag } from "./kit";
import { SAFETY_RULES, CONSERVATION_RULES } from "../../data/oceanContent";
import { ShieldCheck, Leaf, AlertTriangle } from "lucide-react";

export default function Safety() {
  return (
    <section id="safety" data-testid="ocean-safety-section" className="relative py-24 lg:py-32 bg-oabyss/30">
      <div className="absolute inset-0 ocean-grid opacity-30 pointer-events-none" />
      <div className="relative max-w-[1600px] mx-auto px-4 sm:px-8 lg:px-12">
        <Reveal>
          <OceanTag index="06" label="Safety, Responsibility & Conservation" />
          <h2 className="font-display font-bold uppercase tracking-tight text-4xl sm:text-5xl lg:text-6xl text-oseaglass leading-[0.95] max-w-4xl">
            Explore with curiosity. <span className="text-oreef">Dive with responsibility.</span>
          </h2>
          <p className="mt-6 max-w-2xl text-base sm:text-lg text-oseaglass/70 leading-relaxed">
            Diving carries real risk. Every proposed activity must be planned around recognised training, qualified
            supervision and the conditions on the day. This expedition is not a substitute for a recognised diving
            qualification or formal scientific training.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 lg:grid-cols-2 gap-6">
          <Reveal>
            <div className="h-full border border-oreef/15 bg-onavy/50 p-8" data-testid="safety-planning">
              <div className="flex items-center gap-3 mb-6">
                <ShieldCheck size={20} className="text-oreef" strokeWidth={1.6} />
                <h3 className="font-display font-semibold text-xl text-oseaglass tracking-wide">Every dive is planned around</h3>
              </div>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5">
                {SAFETY_RULES.map((r) => (
                  <li key={r} className="text-sm text-oseaglass/70 flex gap-2.5 leading-relaxed"><span className="text-oreef shrink-0 mt-0.5">·</span>{r}</li>
                ))}
              </ul>
            </div>
          </Reveal>
          <Reveal delay={0.08}>
            <div className="h-full border border-oreef/15 bg-onavy/50 p-8" data-testid="conservation-principles">
              <div className="flex items-center gap-3 mb-6">
                <Leaf size={20} className="text-oreef" strokeWidth={1.6} />
                <h3 className="font-display font-semibold text-xl text-oseaglass tracking-wide">Environmental principles</h3>
              </div>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5">
                {CONSERVATION_RULES.map((r) => (
                  <li key={r} className="text-sm text-oseaglass/70 flex gap-2.5 leading-relaxed"><span className="text-oreef shrink-0 mt-0.5">·</span>{r}</li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>

        <Reveal delay={0.12}>
          <div className="mt-6 border border-ocoral/25 bg-ocoral/5 p-7 flex items-start gap-4" data-testid="safety-warning">
            <AlertTriangle size={20} className="text-ocoral shrink-0 mt-0.5" strokeWidth={1.6} />
            <p className="text-sm text-oseaglass/75 leading-relaxed">
              We do not encourage solo diving, unsafe depth progression, unqualified scientific diving, unauthorised wreck
              penetration or diving in dangerous conditions. Deep, technical, cave, decompression and remote offshore
              diving require qualified supervision and appropriate specialist training — they are not routine beginner
              activities.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
